import { render } from "./EditAttachment.vue?vue&type=template&id=701bb966"
import script from "./EditAttachment.vue?vue&type=script&lang=js"
export * from "./EditAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__